var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import deepMerge from 'deepmerge';
import React from 'react';
import ThemeProvider from './ThemeProvider';
// These are the overrides for showing compact text for several typography types
const overridesCompactTheme = {
    typography: {
        h2: {
            fontSize: '20px',
            lineHeight: '24px',
            breakpoints: {
                laptop: {
                    fontSize: '24px',
                    lineHeight: '30px',
                },
            },
        },
        h3: {
            fontSize: '18px',
            lineHeight: '23px',
            breakpoints: undefined,
        },
        h4: {
            fontSize: '14px',
            lineHeight: '17px',
            breakpoints: {
                laptop: {
                    fontSize: '16px',
                    lineHeight: '20px',
                },
            },
        },
        p: {
            fontSize: '16px',
            lineHeight: '20px',
            breakpoints: undefined,
        },
        a: {
            fontSize: '16px',
            lineHeight: '20px',
            breakpoints: undefined,
        },
    },
};
/**
 * This can be used to decorate a component in order to use this specific theme just for it
 *
 *  @example <caption>Decorate a component to enfoce this theme</caption>
 * <ThemeProvider>
 *  <Heading>I am a header with a default style</Heading>
 *  <CompactThemeProvider>
 *    <Heading>I have a compact style</Heading>
 *  </CompactThemeProvider>
 * </ThemeProvider>
 *
 */
const CompactThemeProvider = (_a) => {
    var { overrides: passedOverrides, deep = true, children } = _a, otherProps = __rest(_a, ["overrides", "deep", "children"]);
    /* eslint-disable no-nested-ternary */
    const overrides = passedOverrides
        ? deep
            ? deepMerge(overridesCompactTheme, passedOverrides)
            : Object.assign(Object.assign({}, overridesCompactTheme), passedOverrides)
        : overridesCompactTheme;
    return (React.createElement(ThemeProvider, Object.assign({}, otherProps, { overrides: overrides, deep: deep }), children));
};
export default CompactThemeProvider;
//# sourceMappingURL=CompactThemeProvider.js.map